import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import "../../../App.css";
import { Modal } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Checkbox, IconButton, Typography, Avatar } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate, useParams } from "react-router-dom";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFetchAdminTimeSheetLogDetailsQuery } from "../../../slice/logdetailSlice";
import ReactQuill from "react-quill-new";

const UserTimeSheetTab = () => {
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projects, setProjects] = useState([]);
  const handleShowFilter = () => setShowFilter(true);
  const [showFilter, setShowFilter] = useState(false);
  const [showQuillPopup, setShowQuillPopup] = useState(false);
  const [quillContent, setQuillContent] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);
  const { id } = useParams();
  // //console.log()("show log hours id", id);

  const { data } = useFetchAdminTimeSheetLogDetailsQuery(id);

  // //console.log()("items :", data);

  const [showProject, setShowProject] = useState(false);
  const { reset } = useForm();

  const navigate = useNavigate();
  // const toggleExpandRow = (rowId) => {
  //   setExpandedRows((prevExpandedRows) => ({
  //     ...prevExpandedRows,
  //     [rowId]: !prevExpandedRows[rowId], // Toggle expand state
  //   }));
  // };
  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId], // Toggle expand state
    }));
  };

  const handleMenuOpen = (event, taskId) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(taskId);
  };

  // const getFlattenedRows = () => {
  //   const flattenedRows = [];
  //   data &&
  //     data.forEach((row) => {
  //       flattenedRows.push(row);
  //       if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
  //         row.subtasks.forEach((subtask) => {
  //           flattenedRows.push({ ...subtask });
  //         });
  //       }
  //     });
  //   return flattenedRows;
  // };
  const getFlattenedRows = () => {
    const flattenedRows = [];

    data?.forEach((row) => {
      flattenedRows.push(row); // Add parent row

      if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
        row.subtasks.forEach((subtask) => {
          flattenedRows.push({
            ...subtask,
            parentId: row.id, // Keep reference to parent
            isSubtask: true, // Ensure subtasks are properly identified
          });
        });
      }
    });

    return flattenedRows;
  };

  const handleDashboardClick = (row) => {
    setSelectedRowId(row.id);
    setQuillContent(row.dashBoard || ""); // Load existing notes or empty
    setShowQuillPopup(true);
  };
  useEffect(() => {
    // showAllTimeLogEntities();
  }, []);
  useEffect(() => {
    if (data) {
      setExpandedRows((prev) => {
        const initialExpandedRows = { ...prev };
        data.forEach((row) => {
          if (!(row.id in prev)) {
            initialExpandedRows[row.id] = false; // Default to collapsed
          }
        });
        return initialExpandedRows;
      });
    }
  }, [data]);

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          {params.row.isTask && (
            <IconButton onClick={() => toggleExpandRow(params.row.id)}>
              {expandedRows[params.row.id] ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </IconButton>
          )}
          {params.row.isSubtask && <Checkbox />}
        </Box>
      ),
    },
    {
      field: "user",
      headerName: "Task",
      width: 240,
      // editable: false, // The main task row doesn't need to be editable
      renderCell: (params) => {
        if (params.row.isTask) {
          // Display log_date for task rows
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: "bold" }}>
                {params.row.projectTitle}
              </span>
            </Box>
          );
        } else if (params.row.isSubtask) {
          // //console.log()("params row id :", params.row.id);

          const initials = params.value
            .split(" ")
            .map((word) => word[0])
            .join(""); // Extract initials from name
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <Avatar
                sx={{
                  bgcolor: "#1976d2",
                  width: 24,
                  height: 24,
                  fontSize: "0.75rem",
                }}
              >
                {initials}
              </Avatar>
              <span>{params.value}</span>
            </Box>
          );
        }
        // Default fallback
      },
    },
    {
      field: "logHourse",
      headerName: "Daily Log Hours",
      width: 200,
      // editable: (params) =>
      //   params.row.isSubtask &&
      //   (!params.row.timePeriod || params.row.timePeriod === ""),
      align: "start",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <span>{params.value}</span>
            </Box>
          );
        }
        const logHours = Array.isArray(params.value)
          ? params.value
          : [params.value];
        const getColor = (index) => {
          if (params.row.isSubtask) return "black";
          return index === 0 ? "#00BF00" : index === 1 ? "#34C1FD" : "#FF955A";
        };
        return (
          <Box sx={{ display: "flex", gap: "8px" }}>
            {logHours.map((hour, index) => (
              <Box
                key={index}
                sx={{ color: getColor(index), fontWeight: "bold" }}
              >
                {hour}
              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      field: "Date",
      headerName: "Date",
      width: 150,
      // editable: (params) => params.row.isSubtask,
      align: "left",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              {/* <CustomCalendar /> */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },
    {
      field: "timePeriod",
      headerName: "Time Period",
      width: 180,
      align: "left",
      // editable: (params) => params.row.isSubtask,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },
    {
      field: "dashBoard",
      headerName: "Notes",
      width: 150,
      align: "left",
      // editable: (params) => params.row.isSubtask,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const value = params.value;
          return (
            <div
              // className=" d-flex align-items-center justify-content-center w-100 h-100 "
              onClick={() => handleDashboardClick(params.row)} // Entire cell clickable
            >
              {value.length > 12
                ? value.substring(0, 12) + "..."
                : value || "Edit Notes"}
            </div>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
    {
      field: "billingType",
      headerName: "Status",
      align: "left",
      width: 200,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              <Typography mt={2} color="#34C1FD">
                {params.value}
              </Typography>
            </Box>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
    {
      field: "added_name",
      headerName: "Added By",
      width: 200,
      editable: false,
      // renderCell: (params) => {
    },
  ];

  
  return (
    <>
      <div style={{ padding: "16px", backgroundColor: "white" }}>
        {data?.length > 0 ? (
          <Box style={{ width: "100%", backgroundColor: "transparent" }}>
            <DataGrid
              key={JSON.stringify(expandedRows)} // Forces re-render when expandedRows changes
              // rows={getFlattenedRows()}
              // columns={columns}
              // getRowId={(row) => row.id}
              rows={getFlattenedRows()}
              columns={columns}
              getRowId={(row) => row.id}
              hideFooter
              disableSelectionOnClick
              autoHeight
              sx={{
                "& .MuiDataGrid-cell": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            />
          </Box>
        ) : (
          <Typography
            variant="h6"
            textAlign="center"
            sx={{ marginTop: 2, color: "gray" }}
          >
            No Data Available
          </Typography>
        )}

        <Modal open={showQuillPopup} onClose={() => setShowQuillPopup(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 600,
              maxWidth: 500,
              height: 300,
              bgcolor: "background.paper",
              boxShadow: 10,
              p: 2,
            }}
          >
            <ReactQuill
              theme="snow"
              value={quillContent}
              onChange={(content) => setQuillContent(content)} // Update state
              style={{ height: "150px", marginBottom: "20px" }}
              readOnly={true}
            />
            <Box
              display="flex"
              marginTop={10}
              justifyContent="flex-end"
              gap={2}
            >
              <button
                className="cancel_btn"
                onClick={() => setShowQuillPopup(false)}
              >
                Cancel
              </button>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};
export default UserTimeSheetTab;
